import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLogin } from '../hooks/useAuth';
import { portal } from '../App';
import { getLoginType } from '../utils/subdomain';
import i18n from '../i18n/index';
import { useUiStore } from '../stores/ui.store';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'th', label: 'ภาษาไทย' },
  { code: 'vi', label: 'Tiếng Việt' },
];

export default function LoginPage() {
  const { t } = useTranslation();
  const { setLanguage } = useUiStore();
  const loginMutation = useLogin();

  const mode = getLoginType(portal);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [shopId, setShopId] = useState('');
  const [accountId, setAccountId] = useState('');
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');

    try {
      await loginMutation.mutateAsync({
        username,
        password,
        type: mode,
        shopid: mode === 'retail' ? shopId : undefined,
        account: mode === 'manager' ? accountId : undefined,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  }

  function handleLanguageChange(code: string) {
    setLanguage(code);
    i18n.changeLanguage(code);
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__header">
          <h1 className="login-card__title">motra</h1>
          <p className="login-card__subtitle">
            {mode === 'manager' ? 'Manager Access' : 'Retail Point Access'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {mode === 'retail' && (
            <input
              type="text"
              className="login-input"
              value={shopId}
              onChange={(e) => setShopId(e.target.value)}
              required
              autoFocus
              placeholder="Shop ID"
            />
          )}

          {mode === 'manager' && (
            <input
              type="text"
              className="login-input"
              value={accountId}
              onChange={(e) => setAccountId(e.target.value)}
              required
              autoFocus
              placeholder="Account ID"
            />
          )}

          <input
            type="text"
            className="login-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoComplete="username"
            placeholder="Username"
          />

          <input
            type="password"
            className="login-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="Password"
          />

          {error && (
            <div className="alert alert--error">
              <i className="fa fa-exclamation-circle" /> {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn--primary btn--full btn--lg"
            disabled={loginMutation.isPending}
          >
            {loginMutation.isPending ? (
              <><i className="fa fa-spinner fa-spin" /> Signing in...</>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="login-lang">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              className="login-lang-btn"
              onClick={() => handleLanguageChange(lang.code)}
            >
              {lang.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
